import axios from 'axios';

const service = axios.create({
  timeout: 0,
});

service.interceptors.request.use(
  (config) => {
    // Check if we have an auth token available locally.
    // If so, then add the token to our request.
    if (sessionStorage.getItem('default_auth_token')) {
      config.headers.Authorization = `bearer ${sessionStorage.getItem('default_auth_token')}`;
    } else if (localStorage.default_auth_token) {
      config.headers.Authorization = `bearer ${localStorage.default_auth_token}`;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

export default service;
